import React, { useEffect } from "react";
import ReactGA from "react-ga4";
import { BrowserRouter as Router, Route, Routes, useLocation, useNavigationType } from "react-router-dom";
import NotFound from "./components/NotFound.js";

import Menu from "./components/Menu-Footer/Menu.js";
import Footer from "./components/Menu-Footer/Footer.js";
import Home from './components/Home/Home.js';
import Pricing from './components/Pricing/Pricing.js';
import Bookkeeping from "./components/Services/Bookkeeping/Bookkeeping.js";
import CFO from "./components/Services/CFO/CFO.js";
import Zoho from "./components/Services/Zoho/Zoho.js";
import Tax from "./components/Services/Tax/Tax.js";           
import USA from "./components/Services/USA/USA.js";     
import BlogPage from "./components/Blog/Blog.js";
import BlogPost from "./components/Blog/BlogPost.js";
import Help from "./components/Help/HelpCenter/HelpCenter.js";
import SubmitRequest from "./components/Help/QuerySubmit/SubmitRequest.js";
import PrivacyPolicy from "./components/Privacy Policy/Privacy-policy.js";
import SubscriptionAgreement from "./components/Privacy Policy/SubcriptionAgreement.js";
import ZohoEvent from "./components/Events/ZohoEvent.js";

// Help pages
import GettingStarted from "./components/Help/GettingStarted/GettingStarted.js";
import General1 from "./components/Help/GettingStarted/General1.js";
import General2 from "./components/Help/GettingStarted/General2.js";
import General3 from "./components/Help/GettingStarted/General3.js";
import General4 from "./components/Help/GettingStarted/General4.js";
import General5 from "./components/Help/GettingStarted/General5.js";
import General6 from "./components/Help/GettingStarted/General6.js";
import Resources from "./components/Help/Resources/Resources.js";
import CompanyType1 from "./components/Help/Resources/CompanyType1.js";
import CompanyType2 from "./components/Help/Resources/CompanyType2.js";
import State2 from "./components/Help/Resources/State2.js";
import Restrictions from "./components/Help/Resources/Restrictions.js";
import CompanyName1 from "./components/Help/Resources/CompanyName1.js";
import Refund from "./components/Help/Refund/Refund.js";
import Refund1 from "./components/Help/Refund/Refund1.js";
import Refund2 from "./components/Help/Refund/Refund2.js";
import Refund3 from "./components/Help/Refund/Refund3.js";
import Refund4 from "./components/Help/Refund/Refund4.js";

// Initialize Google Analytics
const MEASUREMENT_ID = "G-YS61J3NWNP";
ReactGA.default.initialize(MEASUREMENT_ID);

// Component to handle scroll to top on route change
const ScrollToTop = () => {
  const { pathname } = useLocation();
  const navType = useNavigationType();

  useEffect(() => {
    if (navType === 'PUSH' || pathname === '/') {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  }, [pathname, navType]);

  return null;
};

// Component to track page views
const TrackPageViews = () => {
  const location = useLocation();

  useEffect(() => {
    ReactGA.default.send({ hitType: "pageview", page: location.pathname });
  }, [location]);

  return null;
};

const Layout = ({ children }) => {
  const location = useLocation();
           
  const excludeMenuFooterRoutes = [
    // "/help", "/submitrequest", "/getting-started", "/resources",
    // "/general1", "/general2", "/general3", "/companytype1",
    // "/companytype2", "/state2", "/restrictions", "/companyname1"
  ];

  if (excludeMenuFooterRoutes.includes(location.pathname)) {
    return <>{children}</>;
  }

  return (
    <>
      <Menu />
      {children}
      <Footer />
    </>
  );
};

function App() {
  return (
    <Router>
      <TrackPageViews /> {/* Google Analytics Tracking */}
      <ScrollToTop /> {/* Handle scroll to top */}
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/bookkeeping" element={<Bookkeeping />} />
          <Route path="/cfo-advisory" element={<CFO />} />
          <Route path="/zoho-advisory" element={<Zoho />} />
          <Route path="/tax-return" element={<Tax />} />
          <Route path="/usa-company-formation" element={<USA />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:id" element={<BlogPost />} />
          <Route path="/help" element={<Help />} />
          <Route path="/submitRequest" element={<SubmitRequest />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/subscription-agreement" element={<SubscriptionAgreement />} />
          <Route path="/events/zoho-books-ahmedabad" element={<ZohoEvent />} />


          {/* Help Pages */}
          <Route path="/getting-started" element={<GettingStarted />} />
          <Route path="/how-the-usa-incorporation-process-word" element={<General1 />} />
          <Route path="/can-a-non-us-resident-or-non-us-citizen-incorporate-in-the-us" element={<General2 />} />
          <Route path="/why-should-your-startup-incorporate-in-the-usa" element={<General3 />} />
          <Route path="/ein-employer-identification-number-what-it-is" element={<General4 />} />
          <Route path="/what-are-the-ongoing-compliance-requirements-after-us-incorporation?" element={<General5 />} />
          <Route path="/opening-a-us-business-bank-account-as-a-non-resident-what-are-your-options?" element={<General6 />} />
          <Route path="/resources" element={<Resources />} />
          <Route path="/single-member-vs-multi-member-llc-which-one-is-right-for-you?" element={<CompanyType1 />} />
          <Route path="/llc-vs-c-corporation-which-business-structure-is-right-for-you?" element={<CompanyType2 />} />
          <Route path="/why-choose-a-wyoming-llc?" element={<State2 />} />
          <Route path="/are-there-any-restricted-countries-for-company-incorporation-in-the-usa?" element={<Restrictions />} />
          <Route path="/restricted-business-names-in-the-us-what-you-need-to-know" element={<CompanyName1 />} />
          <Route path="/refund" element={<Refund />} />
          <Route path="/what-is-your-refund-policy?" element={<Refund1 />} />
          <Route path="/what-payment-methods-do-you-accept?" element={<Refund2 />} />
          <Route path="/how-long-does-it-take-to-process-a-refund?" element={<Refund3 />} />
          <Route path="/can-i-upgrade-or-change-my-service-plan-after-payment?" element={<Refund4 />} />
          {/* 404 - Not Found Page */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;